import { render, staticRenderFns } from "./CMSQuestionnaireDetails.vue?vue&type=template&id=f4c63a1a&"
import script from "./CMSQuestionnaireDetails.vue?vue&type=script&lang=js&"
export * from "./CMSQuestionnaireDetails.vue?vue&type=script&lang=js&"
import style0 from "./CMSQuestionnaireDetails.vue?vue&type=style&index=0&id=f4c63a1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports